import { Injectable } from "@angular/core";
import BaseService from "./base.service";
import { DefaultSelection36CorrespondenceTypePayload } from "@api";

@Injectable({
  providedIn: "root",
})
export default class LocalCorrespondenceTypeService extends BaseService<DefaultSelection36CorrespondenceTypePayload> {}
